import { WASMTensor } from '../../../../tensor/wasm/tensor';
export function sumSparseWASM(tensor, axes, keepDims) {
    return new WASMTensor(tensor.values.wasmTensor.sum_sparse(new Uint32Array(tensor.getShape()), tensor.indices.wasmTensor, new Uint32Array(axes), keepDims), undefined, tensor.dtype);
}
//# sourceMappingURL=wasm.js.map